export const UPLOAD_DOCUMENT = 'UPLOAD_DOCUMENT';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const VALIDATE_DOCUMENT = 'VALIDATE_DOCUMENT';
